import type { ReactNode } from 'react';
import { Camera } from 'lucide-react';
import { cn } from '../../lib/cn.ts';
import { IconButton } from '../icon-button/icon-button.tsx';

export interface ImageUploadButtonProps {
  /* Says what a click does: "Add photo" or "Change photo". */
  'aria-label': string;
  onClick: () => void;
  /* A person is a circle, an organisation's logo a square. */
  shape?: 'circle' | 'square';
  className?: string;
  /* The picture itself, filling the button. */
  children: ReactNode;
}

/**
 * A picture that opens what changes it. There is no button beside it: the
 * thing you were going to click at is the picture, and the camera on hover
 * says it can be changed.
 */
export function ImageUploadButton({
  shape = 'circle',
  className,
  children,
  ...props
}: ImageUploadButtonProps) {
  return (
    <IconButton
      shape={shape}
      className={cn('group relative size-11.5 overflow-hidden', className)}
      {...props}
    >
      {children}

      {/* Dark enough to carry a white icon over a pale picture, and no darker. */}
      <span className='absolute inset-0 flex items-center justify-center bg-primary/60 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100'>
        <Camera className='size-4 text-white' aria-hidden='true' />
      </span>
    </IconButton>
  );
}
